import { AxiosRequestConfig } from "axios";
import { when } from "mobx";
import GlobalStore from "@/store";

export const jdIpRequestInterceptor = async (config: AxiosRequestConfig) => {
    await when(() => !GlobalStore.JdSDKStore.ipLoading);

    const jdipff = GlobalStore.JdSDKStore.ip;

    if (jdipff) {
        config.headers["JDIPFF"] = jdipff;
    }

    return config;
};
